import { occFetch, occUrl } from "~/app/api/occ/occFetch";

const apiUrl = occUrl("/account/update");

export const updateUserInfo = (data: unknown): Promise<unknown> => {
  return occFetch(apiUrl, {
    body: JSON.stringify(data),
    method: "PATCH",
    headers: {
      "content-type": "application/json",
    },
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response;
    }
  });
};
